import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-chevron-down",
  templateUrl: "./med-icon-chevron-down.component.html",
})
export class MedIconChevronDownComponent extends SvgMixinComponent {}
